function dateFormatter(v) {
  if (v) {
    const [d, m, y] = new Date(v)
      .toLocaleDateString('pt-BR', { timeZone: 'UTC' })
      .split('/');
    return `${y.padStart(4, '0')}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
  } else {
    return v;
  }
}

export { dateFormatter }